import axios from 'axios'
import {createSlice, createAsyncThunk, PayloadAction} from '@reduxjs/toolkit'
const api = '/api/'

export const studentUniformList = createAsyncThunk(
  'school-student-uniform-list',
  async (params: {}, thunkAPI) => {
    try {
      const response = await axios.get(`${api}school-student-uniform/list`, params)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const storeStudentUniform = createAsyncThunk(
  'school-student-uniform-store',
  async (data: {}, thunkAPI) => {
    try {
      const response = await axios.post(`${api}school-student-uniform/store`, data)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data)
      }
    }
  }
)

export const getStudentUniformById = createAsyncThunk(
  'school-student-uniform-get',
  async (student_uniform_id: any, thunkAPI) => {
    try {
      const response = await axios.get(`${api}school-student-uniform/edit/` + student_uniform_id)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data)
      }
    }
  }
)

export const ReturnUniforms = createAsyncThunk('return-uni', async (dat: any, thunkAPI) => {
  try {
    const {data} = await axios.post(`${api}school-student-uniform/return-sale`, dat)
    return data
  } catch (error: any) {
    return thunkAPI.rejectWithValue(error.response?.data?.errors)
  }
})

export const viewStudentUniform = createAsyncThunk(
  'school-student-uniform-view',
  async (student_uniform_id: any, thunkAPI) => {
    try {
      const response = await axios.get(`${api}school-student-uniform/view/` + student_uniform_id)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data)
      }
    }
  }
)

export const printStudentUniform = createAsyncThunk(
  'student-uniform-print',
  async (id: string, thunkAPI) => {
    try {
      const response = await axios.get(`${api}school-student-uniform/print/${id}`)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const StdUniformPayments = createAsyncThunk(
  'uniform-payments',
  async (id: any, thunkAPI) => {
    try {
      const response = await axios.get(`${api}school-student-uniform/payments/` + id)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data)
      }
    }
  }
)

type StudentUniformState = {
  errors: any
}

const initialState: StudentUniformState = {
  errors: '',
}

export const studentUniformSlice = createSlice({
  name: 'student-uniform',
  initialState,
  reducers: {
    reset: () => initialState,
  },
  extraReducers: (builder) => {
    builder.addCase(storeStudentUniform.rejected, (state, action: PayloadAction<any>) => {
      state.errors = action.payload
    })
  },
})

export const {reset} = studentUniformSlice.actions
export default studentUniformSlice.reducer
